import type { PatsnapCopilotUsage } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';

export const PatsnapCopilotUsageService = Symbol.for('PatsnapCopilotUsageService');

export interface PatsnapCopilotUsageService {
    getUsage(): Promise<PatsnapCopilotUsage>;
}
